<template>
  <header
    id="site-header"
    class="header"
  >
    <div class="page-title">
      <h6>Main Page After Login</h6>
    </div>


    <div class="header-content-wrapper">
      <!--<router-link
        v-if="ppa=='personal'"
        to="/personal/financial-standards"
        class="link-find-friend"
      >
        Financial Standards
      </router-link>
      <router-link
        v-if="ppa=='personal'"
        to="/personal/financial-standards-2"
        class="link-find-friend"
      >
        Financial Standards 2
      </router-link>
      <router-link
        v-if="ppa=='personal'"
        to="/personal/human-needs"
        class="link-find-friend"
      >
        Human Needs
      </router-link>
      <router-link
        v-if="ppa=='personal'"
        to="/personal/believes"
        class="link-find-friend"
      >
        Believes
      </router-link>-->

      <router-link
        v-if="ppa=='per' && subApp && subApp === 'all'"
        to="/all/planning2"
        class="link-find-friend"
      >
        Planning New
      </router-link>

      <router-link
        v-if="ppa=='per' && subApp && subApp === 'all'"
        to="/all/wishlist"
        class="link-find-friend"
      >
        Wishlist
      </router-link>

      <router-link
        v-if="ppa=='per' && subApp && subApp === 'men'"
        to="/men/goals2"
        class="link-find-friend"
      >
        Goals
      </router-link>

      <router-link
        v-if="ppa=='per' && subApp && subApp === 'men'"
        to="/men/method/1"
        class="link-find-friend"
      >
        Method
      </router-link>

      <router-link
        v-if="ppa=='per' && subApp && subApp === 'men'"
        to="/men/human-actions"
        class="link-find-friend"
      >
        Human Actions
      </router-link>



      <div class="control-block">
        <div class="author-page author vcard inline-items more">
          <div class="author-thumb">
            <img
              alt="author"
              :src="imgNico"
              class="avatar"
            >
            <span class="icon-status" />
          </div>
          <a
            href="#"
            class="author-name fn"
          >
            <div class="author-title">{{ user.username }}
              <!-- classes: sprite-icon olymp-dropdown-arrow-icon -->
              <app-icon
                name="olymp-dropdown-arrow-icon"
                color="gray"
                size="large"
              />
            </div>
            <span class="author-subtitle">HOME APP</span>
            <button
              class="logout"
              @click="onLogout"
            >Logout</button>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import imgNico from '../../../../static/img/nico-profile.jpg'
import AppIcon from "./AppIcon";

export default {
  name: 'HeaderBp',
  components: { AppIcon },
  props: {
    user: {
      type: Object,
      default: function () { return {} }
    },
    ppa: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      app: this.ppa,
      apps: ['personal', 'familial', 'financial', 'mental', 'physical', 'social', 'spiritual', 'vocational'],
      imgNico: imgNico,
      subApp: ''
    }
  },
  computed: {
    auth () {
      return this.$store.getters['account/isAuthenticated']
    }
  },
  mounted() {
    let subApp = this.$route.path.substr(1, 3);
    this.subApp = subApp;
  },
  methods: {
    onLogout () {
      this.$store.dispatch('account/logout')
    },
    switchApp() {
      this.$store.dispatch('account/logout', this.app)
    }
  }
}
</script>
